import { useIntl } from 'react-intl';
import { Marker, NavigationControl, Map as ReactMapGL } from 'react-map-gl/mapbox';
import { ButtonUI } from 'sonata-react-components';
import { Venue } from 'sonata-static-storage/lib/schemas/venue/venue.schema';

import { openGoogleMaps } from '@/helpers/common/poiAttribution.helper';

import './venueMap.scss';

export type Props = {
  venue: Venue<string>;
};

export function VenueMap({ venue }: Readonly<Props>) {
  const { formatMessage } = useIntl();
  const mapId = `myVenueMap_${venue._id}`;
  const MIN_ZOOM = 4;
  const MAX_ZOOM = 18;
  const initialViewState = {
    latitude: venue.latlng.lat,
    longitude: venue.latlng.lng,
    zoom: 13
  };

  return (
    <div className="venueMap">
      <div className="venueMap__canvas">
        <ReactMapGL
          attributionControl={false}
          id={mapId}
          initialViewState={initialViewState}
          mapStyle="mapbox://styles/mapbox/streets-v12"
          mapboxAccessToken={taptap.config.mapbox.accessToken}
          maxZoom={MAX_ZOOM}
          minZoom={MIN_ZOOM}
          scrollZoom
        >
          <NavigationControl position="bottom-right" showCompass={false} visualizePitch={false} />
          <Marker latitude={venue.latlng.lat} longitude={venue.latlng.lng}>
            <i className="fa-solid fa-location-dot venueMap__marker" />
          </Marker>
        </ReactMapGL>
      </div>
      <ButtonUI
        className="venueMap__goToMapButton"
        icon="fa-regular fa-map"
        iconPosition="left"
        id={`${mapId}-goToMap`}
        onClick={() => openGoogleMaps(venue)}
        size="small"
        text={formatMessage({ defaultMessage: 'Go to map', id: 'menu.myVenues.map.goToMap' })}
        type="primary"
      />
    </div>
  );
}
